import React from "react";
import { useCurrentAccountQuery } from "../../../api/queries/useAccountQuery";
import { SETTINGS_ROUTES } from "../../../consts/routes";
import { ConfirmModal } from "../../../boxes/ConfirmModal/ConfirmModal";
import { useLocalStorageState } from "../../../hooks/useLocalStorageState";
import { history } from "../../../history";
import { LOCAL_STORAGE_KEYS } from "../../../consts/localStorage";
import { WORKSPACE_STATUS } from "../../../consts/api";

export const TwoFactorVerificationSetupPopup = () => {
  const { data: account } = useCurrentAccountQuery();

  const [isSkipped, setIsSkipped] = useLocalStorageState(
    LOCAL_STORAGE_KEYS.twoFactorVerificationSetupSkipped,
    "false",
    {
      enableInit: false,
    },
  );

  const isOpen =
    account?.globalSettings?.twoFactorVerificationSetup?.needsSetup &&
    account?.globalSettings?.accountStatus === WORKSPACE_STATUS.active &&
    !window.location.pathname.startsWith(SETTINGS_ROUTES.profile()) &&
    isSkipped !== "true";

  const canSkip = account?.globalSettings?.twoFactorVerificationSetup?.canSkip;

  return (
    <ConfirmModal
      key={window.location.pathname}
      isOpen={isOpen}
      withAlertIcon
      title="2FA Verification Update"
      onConfirm={() => history.push(SETTINGS_ROUTES.profile())}
      confirmTitle="Configure"
      cancelTitle="Remind Me"
      onCancel={canSkip ? () => setIsSkipped("true") : undefined}
    >
      <p>
        {`We've added additional verification options to ensure an efficient login
        process with 2FA if your device is unable to receive an OTP code via SMS
        for any reason.`}
      </p>
      <br />
      <p>
        Please set up your required passcode and security question so we can
        send an OTP code to your email if needed.
      </p>
      <br />
      <p>
        <b>Tip:</b>{" "}
        {`Skip the 2FA requirement for ${
          account?.globalSettings?.twoFactorTrustDays || 14
        } days by enabling the option
        to Trust This Device when logging in.`}
      </p>
    </ConfirmModal>
  );
};
